<template>
  <div class="containerHome">
    <div class="homesDetail">
      <div class="right_title">
        当前位置：
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: '/moreDetail?category=' + category }"
            >{{ categoryName[category] }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="title">{{ form.title }}</div>
      <div class="topCon">
        发布时间：{{ form.releaseTime }} &nbsp;&nbsp;&nbsp;&nbsp;  来源：{{
          form.articleSource
        }}  
      </div>
      <div v-html="form.content"></div>
    </div>
  </div>
</template>
<script>
import { getNotice } from "@/api/desk/notice";
import { mixins } from "@/mixins/index";
export default {
  name: "Guidanceunit",
  mixins: [mixins],
  data() {
    return {
      api: null,
      form: {},
    };
  },
  mounted() {
    if (!["1", "2"].includes(this.$route.query.category)) {
      this.api = require(`@/api/desk/${this.$route.query.category}`);
    }
    this.getDetail();
  },
  methods: {
    getDetail() {
      let Api = null;
      /* 通知公告 */
      if (["1", "2"].includes(this.$route.query.category)) {
        Api = getNotice;
      } else {
        /* 其他11个模块 */
        Api = this.api["getDetail"];
      }
      Api(this.$route.query.id).then((res) => {
        this.form = res.data;
      });
    },
  },
};
</script>
<style scoped lang="less">
.homesDetail {
  padding: 20px 50px 50px;
  @media (min-width: 768px) and (max-width: 1200px) {
    padding: 20px 40px 40px;
  }
  @media (max-width: 768px) {
    padding: 20px;
  }
  box-sizing: border-box;
  border-radius: 11px;
  background: #fff;
  margin: 20px 0;
  .right_title {
    height: 50px;
    line-height: 50px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    font-size: 14px;
    @media (max-width: 768px) {
      font-size: 12px;
      :deep(.el-breadcrumb) {
        font-size: 12px;
      }
    }
  }
  .title,
  .topCon {
    margin: 0 auto;
    text-align: center;
    line-height: 26px;
  }
  .div {
    line-height: 26px;
  }
  .title {
    font-size: 24px;
    @media (min-width: 768px) and (max-width: 1200px) {
      font-size: 22px;
    }
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 32px;
    }
  }

  .topCon {
    font-size: 14px;
    color: #797979;
    margin: 20px 0 40px 0;
    @media (min-width: 768px) and (max-width: 1200px) {
      font-size: 13px;
    }
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
}
</style>